import { useRef, useState } from "react";

function fallbackCopy(text: string) {
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.setAttribute("readonly", "");
  ta.style.position = "fixed";
  ta.style.opacity = "0";
  document.body.appendChild(ta);
  ta.select();
  try {
    document.execCommand("copy");
  } catch {
    /* ignore */
  }
  document.body.removeChild(ta);
}

/** Copy button with the rotated "copied!" stamp shown for ~1.8s. */
export function CopyButton({
  text,
  label = "Copy prompt",
  onCopied,
}: {
  text: string;
  label?: string;
  /** Fired once per successful copy — used for fire-and-forget analytics. */
  onCopied?: () => void;
}) {
  const [copied, setCopied] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  function flash() {
    setCopied(true);
    onCopied?.();
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => setCopied(false), 1800);
  }

  function onClick() {
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(text).then(flash, () => {
        fallbackCopy(text);
        flash();
      });
    } else {
      fallbackCopy(text);
      flash();
    }
  }

  return (
    <>
      <span className={`copied-stamp${copied ? " show" : ""}`} aria-hidden="true">
        copied!
      </span>
      <button type="button" className="copy-btn" onClick={onClick}>
        {copied ? "Copied" : label}
      </button>
    </>
  );
}
